import React from 'react';
import { Box, Paper, Typography, Button } from '@mui/material';

const AlertModal = ({ 
  open, 
  onClose, 
  onConfirm, 
  title = "Confirm Action",
  message = "Are you sure you want to perform this action?",
  confirmText = "OK",
  cancelText = "Cancel"
}) => {
  if (!open) return null;

  return (
    <Box sx={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      zIndex: 9999,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <Paper sx={{ padding: 3, maxWidth: 300, textAlign: 'center' }}>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          {message}
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          <Button 
            variant="outlined" 
            onClick={onClose}
          >
            {cancelText}
          </Button>
          <Button 
            variant="contained" 
            color="primary"
            onClick={onConfirm}
          >
            {confirmText}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default AlertModal;